import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import * as moment from 'moment';
import 'moment-timezone';
import * as md5 from 'md5';
import { environment } from '../../../../environments/environment';

import * as appSelectors from '../../state-management/reducers';

@Injectable()
export class PrrlFormButlerTokenService {
	public constructor(
		private _store: Store<appSelectors.State>,
	) {}

	public getToken(): string {
		let selectedAgency: number = -1;
		this._store.select(appSelectors.getSelectedAgency).take(1).subscribe(agency => selectedAgency = agency.agentId).unsubscribe();

		const now = moment().tz('Europe/Berlin');
		return md5(`${selectedAgency}${now.format('YYYYMMDD')}${environment.xena.formButler.token}${now.format('HH')}`);
	}

	public getClickAndLearnToken(): string {
		const now = moment().tz('Europe/Berlin');
		return md5(`${now.format('YYYYMMDD')}${environment.xena.formButler.token}${now.format('HH')}`);
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/components/prrl-form-butler-dialog/prrl-form-butler-token.service.ts